import React from 'react';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';

import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiLinkedin,
  FiYoutube,
} from 'react-icons/fi';

import callicon from '@/assets/images/call-icon.png';
import chatcon from '@/assets/images/chat-icon.png';
import whatsappicon from '@/assets/images/whatsapp-icon.png';

import { Link } from 'react-router-dom';
import logo from '@/assets/images/logo.webp';
import { SiWebmoney } from 'react-icons/si';

const Footer = () => {
  const IconCircle = ({ children }) => (
    <div className="min-w-[26px] min-h-[26px] w-6 h-6 rounded-full bg-white text-[#77787a] flex items-center justify-center">
      {children}
    </div>
  );

  const ContactRow = ({ icon, children, center = false }) => (
    <div className={`flex ${center ? 'items-center' : 'items-start'} gap-2 lg:mb-6 mb-4`}>
      <IconCircle>{icon}</IconCircle>
      <div className="text-white text-xs leading-tight">{children}</div>
    </div>
  );

  const locations = [
    {
      city: 'JAIPUR',
      phone: ['08071822869'],
      //phone: ['+91 141 2720557','08071822869'],
      email: 'contact@kgkrealty.com',
      web: "kgkrealty.com",
      address: 'KGK Realty (India) Limited, E.P. Campus, Near Jawahar Circle, JLN Marg, Jaipur, Rajasthan, 302017',
    },
    {
      city: 'MUMBAI',
      phone: ['+91 22 4028 8888'],
      //email: 'contact@kgkrealty.com',
      web: "kgkrealty.com",
      address: '3rd Floor, KGK Tower II, Dattapada Road, Rajendra Nagar, Near Ekta Bhoomi Gardens, Borivali (East), Mumbai 400066, Maharashtra, India',
    },
  ];

  const quickLinks = [
    { label: 'HOME', path: '/' },
    { label: 'ABOUT KGK REALTY', path: '/about-us' },
    { label: 'MEDIA - IN THE PRESS', path: '/media' },
   // { label: 'PROJECTS', path: '/project' },
    { label: 'PARTNERS IN GROWTH', path: '/partner' },
    { label: 'CAREERS', path: '/career' },
    { label: 'BLOGS', path: '/blog' },
    { label: 'CONTACT', path: '/contact-us' },
    { label: 'AWARDS', path: '/award' },
    // { label: 'CERTIFICATIONS ', path: '/certifications' },
    { label: ' PRIVACY POLICY ', path: '/privacy-policy' },
  ];

  const socialIcons = [
    { icon: FiFacebook, url: 'https://www.facebook.com/kgkrealty/' },
    { icon: FiInstagram, url: 'https://www.instagram.com/kgk_realty/' },
    { icon: FiTwitter, url: 'https://twitter.com/KgkRealty/' },
    { icon: FiLinkedin, url: 'https://www.linkedin.com/company/kgk-realty/mycompany' },
    { icon: FiYoutube, url: 'https://www.youtube.com/results?search_query=kgkrealty' },
  ];

  return (
    <footer className="bg-[#77787a] text-white text-xs pb-20">
      {/* Top Row with Logo and Social Links */}
      <div className="lg:px-12 px-6 pt-10 grid sm:grid-cols-2 grid-cols-2 lg:gap-8 items-center">
        <div>
          <img src={logo} alt="KGK Realty" className="w-16" />
        </div>
        <div>
          <div className="flex lg:gap-3 gap-2 lg:justify-end">
            {socialIcons.map(({ icon: Icon, url }, index) => (
              <a
                key={index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-7 h-7 lg:w-8 lg:h-8 rounded-full border border-white text-white flex items-center justify-center hover:bg-white hover:text-[#77787a] transition-colors duration-200"
              >
                <Icon className="lg:text-base text-sm" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Contact & Quick Links */}
      <div className="lg:px-12 px-6 py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:gap-8 gap-3">
        {locations.map(({ city, phone, email, address, web }) => (
          <div key={city}>
            <h3 className="text-base font-semibold mb-5">{city}</h3>

            {/* Phone */}
            <ContactRow icon={<FaPhoneAlt className="lg:text-sm text-xs" />} center>
              <div className="flex flex-col">
                {phone.map((num, i) => (
                  <a
                    key={i}
                    href={`tel:${num.replace(/\s+/g, '')}`}
                    className="lg:text-sm text-xs text-white hover:underline"
                  >
                    {num}
                  </a>
                ))}
              </div>
            </ContactRow>

            {/* Email */}
            {email && (
            <ContactRow icon={<FaEnvelope className="lg:text-sm text-xs" />} center>
              <a
                href={`mailto:${email}`}
                className="lg:text-sm text-xs text-white hover:underline"
              >
                {email}
              </a>
            </ContactRow>
            )}

            {/* Website */}
            {/* <ContactRow icon={<SiWebmoney className="lg:text-sm text-xs" />} center>
              <a
                href={`https://${web}`}
                target="_blank"
                rel="noopener noreferrer"
                className="lg:text-sm text-xs text-white hover:underline"
              >
                {web}
              </a>
            </ContactRow> */}

            {/* Address */}
            <ContactRow icon={<FaMapMarkerAlt className="lg:text-sm text-xs" />}>
              <p className="lg:text-sm text-xs">{address}</p>
            </ContactRow>
          </div>
        ))}

        {/* Quick Links */}
        <div>
          <h3 className="text-base font-semibold mb-5">QUICK LINKS</h3>
          <div className="grid grid-cols-2 gap-x-3 gap-y-4">
            {quickLinks.map(({ label, path }, index) => (
              <Link
                to={path}
                key={index}
                className="lg:text-sm text-xs hover:underline transition-colors duration-200 hover:no-underline"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center text-sm bg-[#a5a5a5] py-4 mb-10 lg:mb-0">
        © 2025
        <a href="https://kgkrealty.com" className="mx-1 underline hover:no-underline">KGK REALTY</a>
        ALL RIGHTS RESERVED <br></br>Disclaimer: This website is meant only for informational purposes & it does not advertise, market, book, sell or offer for sale or invite persons to purchase in any manner any of the real estate products as displayed on it.
      </div>

      {/* Mobile Sticky Footer CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t md:hidden">
        <div className="grid grid-cols-3 gap-2 p-2">

          {/* WhatsApp */}
          <a
            href="https://api.whatsapp.com/send/?phone=918824100200&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold text-white"
            style={{ backgroundColor: "#1FAF38" }}
          >
            <img src={whatsappicon} alt="whatsappicon" className="h-5" />
          </a>

          {/* Chat */}
          <button
            className="relative flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold text-white"
            style={{ backgroundColor: "#99642e" }} onClick={() => window.Tawk_API?.maximize()}
          >
             <img src={chatcon} alt="chatcon" className="h-5" />
            {/* Online Dot */}
            <span
              className="absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-white"
              style={{ backgroundColor: "#19C37D" }}
            />
          </button>

          {/* Call */}
          <a
            href="tel:+918071822869"
            className="flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold text-white"
            style={{ backgroundColor: "#ea4d37" }}
          >
            <img src={callicon} alt="callicon" className="h-5" />
          </a>

        </div>
      </div>      

    </footer>
  );
};

export default Footer;
